import axios from "axios";

const TOKEN = "eyJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJIaWV1TkRIRSIsInN1YiI6Ik5ndXllbiBEdWMgSGlldSIsImV4cCI6MTc0MDU1MDk4NCwiaWF0IjoxNzQwNTQ3Mzg0LCJqdGkiOiJiNGE3YmUxYi03ODY2LTQ1NmUtOTcwNy1hMDU1ZGJjZDE1NDkiLCJzY29wZSI6IlJPTEVfTUFOQUdFUiJ9.YQDuREFfWVxJ7KgBEwteM-cx1LWrTQBbjU7lWsBdZ9o";
const API_BASE_URL = "https://pro.api.cotrangvietvutamthu.com/api/v1";

const api = axios.create({
    baseURL: API_BASE_URL,
    headers: {
        "Content-Type": "application/json",
        "ngrok-skip-browser-warning": "true",
    },
    withCredentials: true,
});

api.interceptors.request.use(
    (config) => {
        try {
            if (typeof window !== "undefined") { 
                const token = localStorage.getItem("token");
                if (token) {
                    config.headers["Authorization"] = `Bearer ${token}`;
                }

                const userTenantId = Number(localStorage.getItem("userTenantId"));
                if (userTenantId) {
                    config.headers["X-TENANT-ID"] = userTenantId;
                }
            }
        } catch (error) {
            console.error("Error accessing localStorage:", error);
        }
        return config;
    },
    (error) => {
        console.error("Request interceptor error:", error);
        return Promise.reject(error);
    }
);

let isRefreshing = false; // Flag to indicate if the token is being refreshed
let failedQueue = []; // Queue to store failed requests

const processQueue = (error, token = null) => {
    failedQueue.forEach((prom) => {
        if (token) {
            prom.resolve(token);
        } else {
            prom.reject(error);
        }
    });
    failedQueue = [];
};

api.interceptors.response.use(
    (response) => {
        return response;
    },
    async (error) => {
        const originalRequest = error.config;

        if (error.response && error.response.status === 401 && !originalRequest._retry) {
            if (isRefreshing) {
                // If a refresh is already in progress, queue the request
                return new Promise((resolve, reject) => {
                    failedQueue.push({ resolve, reject });
                })
                    .then((token) => {
                        originalRequest.headers["Authorization"] = `Bearer ${token}`;
                        return api.request(originalRequest);
                    })
                    .catch((err) => {
                        return Promise.reject(err);
                    });
            }

            originalRequest._retry = true; // Mark the request as retried
            isRefreshing = true;

            try {
                const refreshToken = localStorage.getItem("refreshToken");

                if (!refreshToken) {
                    throw new Error("No refresh token available");
                }

                const { data } = await axios.post(
                    `${API_BASE_URL}/authentication/refresh`,
                    { token: refreshToken },
                    {
                        headers: {
                            "Content-Type": "application/json",
                        },
                    }
                );

                const newAccessToken = data.data;
                localStorage.setItem("token", newAccessToken);

                // Process the queued requests
                processQueue(null, newAccessToken);

                // Retry the original request with the new token
                originalRequest.headers["Authorization"] = `Bearer ${newAccessToken}`;
                return api.request(originalRequest);
            } catch (refreshError) {
                console.error("Error refreshing token:", refreshError);

                // Clear localStorage and redirect to login if refresh fails
                localStorage.removeItem("token");
                localStorage.removeItem("refreshToken");
                localStorage.removeItem("userTenantId");

                if (typeof window !== "undefined") {
                    window.location.href = "/login";
                }

                // Reject all queued requests
                processQueue(refreshError, null);
                return Promise.reject(refreshError);
            } finally {
                isRefreshing = false; // Reset the refreshing flag
            }
        }

        return Promise.reject(error);
    }
);

export default api;
